export default "__VITE_ASSET__DNNCyiGN__"